import { lazy } from 'react'
import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'

import { GoalPage } from './GoalPage/GoalPage'

const ImpactContainer = lazy(() => import('./ImpactContainer/ImpactContainer'))

const ImpactReportDashboard = lazy(
  () => import('./ImpactReportDashboard/ImpactReportDashboard')
)

const GoalsDashboard = lazy(() => import('./GoalsDashboard/GoalsDashboard'))

const ImpactStoriesPage = lazy(
  () => import('./ImpactStories/ImpactStoriesPage/ImpactStoriesPage')
)

const ImpactStoriesPageContainer = lazy(
  () =>
    import(
      './ImpactStories/ImpactStoriesPageContainer/ImpactStoriesPageContainer'
    )
)

const StoryEditContainer = lazy(
  () => import('./ImpactStories/StoryEditContainer/StoryEditContainer')
)

const PublishedImpactStory = lazy(
  () => import('./ImpactStories/PublishedImpactStory/PublishedImpactStory')
)

const impact = {
  path: '/impact',
  exact: false,
  Component: WithPermission(ImpactContainer, ['page:impact'], true),
  access: 'USER',
  routes: [
    {
      // Legacy routes that eventually can be removed
      path: [`/impact/initiatives`, `/impact/templates`, '/impact/goals'],
      exact: true,
      Component: GoalsDashboard,
      access: 'USER',
    },
    {
      path: '/impact/goals/wizard',
      exact: true,
      Component: GoalsDashboard,
      access: 'USER',
    },
    {
      path: '/impact/goals/:goalId',
      exact: true,
      Component: GoalPage,
      access: 'USER',
    },
    {
      path: [`/impact/dashboard`],
      exact: true,
      Component: WithPermission(
        ImpactReportDashboard,
        ['page:impact:dashboard'],
        true
      ),
    },
    {
      path: `/impact/stories`,
      exact: false,
      Component: ImpactStoriesPageContainer,

      access: 'USER',
      routes: [
        {
          path: `/impact/stories/published`, // TODO: This route shows published AND unpublished stories
          exact: true,
          Component: ImpactStoriesPage,

          access: 'USER',
        },
        {
          path: `/impact/stories/view/:id`,
          exact: true,
          Component: PublishedImpactStory,

          access: 'USER',
        },
        {
          path: `/impact/stories/new/:templateName`,
          exact: true,
          Component: StoryEditContainer,
          access: 'USER',
        },
        {
          path: `/impact/stories/edit/:id`,
          exact: true,
          Component: StoryEditContainer,
          access: 'USER',
        },
      ],
    },
  ],
}

export default impact
